var map = {
	"./basket.json": 2404,
	"./contacts.json": 8574,
	"./customer.json": 3709,
	"./customers.json": 5921,
	"./customervisit.json": 9326,
	"./customervisits.json": 1331,
	"./dashboard.json": 420,
	"./deligatedtasks.json": 5783,
	"./detailview.json": 3523,
	"./expensereport.json": 4867,
	"./leads.json": 1031,
	"./offers.json": 6801,
	"./presales.json": 8494,
	"./reports.json": 6082,
	"./systeminfo.json": 8046,
	"./tasks.json": 3413,
	"./timerecording.json": 9060,
	"./timerecordingoverview.json": 8906,
	"./user.json": 1333,
	"Data/Designer/Defaultpages/basket.json": 2404,
	"Data/Designer/Defaultpages/contacts.json": 8574,
	"Data/Designer/Defaultpages/customer.json": 3709,
	"Data/Designer/Defaultpages/customers.json": 5921,
	"Data/Designer/Defaultpages/customervisit.json": 9326,
	"Data/Designer/Defaultpages/customervisits.json": 1331,
	"Data/Designer/Defaultpages/dashboard.json": 420,
	"Data/Designer/Defaultpages/deligatedtasks.json": 5783,
	"Data/Designer/Defaultpages/detailview.json": 3523,
	"Data/Designer/Defaultpages/expensereport.json": 4867,
	"Data/Designer/Defaultpages/leads.json": 1031,
	"Data/Designer/Defaultpages/offers.json": 6801,
	"Data/Designer/Defaultpages/presales.json": 8494,
	"Data/Designer/Defaultpages/reports.json": 6082,
	"Data/Designer/Defaultpages/systeminfo.json": 8046,
	"Data/Designer/Defaultpages/tasks.json": 3413,
	"Data/Designer/Defaultpages/timerecording.json": 9060,
	"Data/Designer/Defaultpages/timerecordingoverview.json": 8906,
	"Data/Designer/Defaultpages/user.json": 1333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2661;